import React, { useContext, useEffect, useState } from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components'
import { Variables } from '../styles/Variables'
import LayoutContext from './LayoutContext'
import media from 'css-in-js-media'

import CheckIcon from '../svg/check.svg'
import { motion, useAnimation } from 'framer-motion'

export const LanguageLinks = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 100%;
    left: 50%;
    padding: 7.5px 20px;
    display: flex;
    background-color: ${Variables.color.white};
    margin-top: 30px;
    white-space: nowrap;
    flex-direction: column;
    min-width: 90px;
    box-sizing: border-box;
    pointer-events: none;
    opacity: 0;
    transition: 0.3s opacity ease-out, 0.3s transform ease-out;
    transition-timing-function: cubic-bezier(0.29, 0.46, 0.1, 1);
    transform: translateX(-50%) translateY(-10px);

    will-change: opacity, transform;

    svg {
        height: 14px;
        width: 14px;
    }

    a {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
`
const Arrow = styled.div`
    display: flex;
    align-items: center;
    margin-left: 10px;
    svg {
        transition: 0.2s transform ease-out;
    }
    svg path {
        stroke: ${Variables.color.cocoa};
    }
`

export const LanguageSwitcher = styled.div`
    position: relative;
    margin-right: 22px;
    padding: 15px;
    color: ${Variables.color.cocoa};
    cursor: pointer;
    text-transform: uppercase;
    font-family: ${Variables.font.bodyBold};
    font-size: 14px;
    line-height: 17px;
    text-align: center;

    ${media('<desktop')} {
        font-size: 12px;
        line-height: 14px;
    }

    :hover {
        color: ${Variables.color.cocoa};

        ${Arrow} svg {
            transform: rotate(-180deg);
        }

        svg path {
            stroke: ${Variables.color.cocoa};
        }
        ${LanguageLinks} {
            transform: translateX(-50%) translateY(0);
            opacity: 1;
            pointer-events: all;
            :before {
                content: '';
                bottom: 100%;
                left: 10px;
                right: 35px;
                height: 80px;
                position: absolute;
            }
        }
    }
`

const LanguageLinkWrap = styled.li`
    margin: 3px 0;
    font-size: 14px;
    line-height: 26px;
    letter-spacing: 0.0125em;
    text-transform: uppercase;
`

const LanguageLink = styled(Link)`
    color: ${Variables.color.cocoa};
    text-decoration: none;

    :hover {
        opacity: 0.8;
    }
`

const InnerWrapper = styled.div`
    display: flex;
    align-items: center;
    text-transform: uppercase;
`

const LanguageSelected = styled.div``

const setLanguageDetected = () => {
    localStorage.setItem('pazolaLanguageDetected', 'yes')
}

const SelectLanguage = () => {
    const { languageData, currentLang, isLanguageMenuOpen } = useContext(
        LayoutContext
    )

    const controls = useAnimation()

    useEffect(() => {
        controls.start(isLanguageMenuOpen ? 'active' : 'inactive') // Second should be 'inactive'
    }, [isLanguageMenuOpen, controls])

    const langSelected = currentLang.langKeyShort
    const links = languageData.map((lang) => (
        <LanguageLinkWrap key={lang.langKey}>
            <LanguageLink
                to={lang.link}
                key={lang.langKey}
                onClick={() => setLanguageDetected()}
            >
                {lang.labelDesktop}
                {lang.selected && <img src={CheckIcon} alt="" />}
            </LanguageLink>
        </LanguageLinkWrap>
    ))

    return (
        <LanguageSwitcher>
            <InnerWrapper>
                <LanguageSelected>{langSelected}</LanguageSelected>
                <Arrow>
                    <svg
                        width="17"
                        height="10"
                        viewBox="0 0 17 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M16 1L8.5 8.5L1 0.999999"
                            stroke={Variables.color.white}
                            strokeMiterlimit="10"
                        />
                    </svg>
                </Arrow>
            </InnerWrapper>
            <LanguageLinks>{links}</LanguageLinks>
        </LanguageSwitcher>
    )
}

export default SelectLanguage
